import KiqQuestionsStep from './KiqQuestionsStep';

export default KiqQuestionsStep;
